// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%2366bf01%27 fill-opacity=%270.05%27%3E%3Cpath d=%27M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Loans Hero Section - Updated Design */
.loans-hero {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 5rem 0;
  position: relative;
  overflow: hidden;
}

.loans-hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  z-index: 0;
}

.loans-hero-content {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
}

.hero-text {
  max-width: 600px;
}

.eyebrow {
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--brand-primary);
  margin-bottom: 1rem;
  background: rgba(102, 191, 1, 0.1);
  padding: 0.5rem 1rem;
  border-radius: 50px;
}

.hero-text h1 {
  font-size: 2.75rem;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  color: var(--brand-dark);
}

.hero-text .gradient-text {
  background: linear-gradient(90deg, var(--brand-primary), #4F8A10);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 800;
}

.subtitle {
  font-size: 1.125rem;
  color: var(--text-secondary);
  margin-bottom: 2rem;
  line-height: 1.7;
}

.features-list {
  list-style: none;
  padding: 0;
  margin: 2rem 0;
}

.features-list li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
  color: var(--text-primary);
  font-weight: 500;
}

.feature-icon {
  color: var(--brand-primary);
  margin-right: 0.75rem;
  flex-shrink: 0;
  margin-top: 0.25rem;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
}

.btn {
  padding: 0.875rem 1.75rem;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px solid transparent;
}

.btn-primary {
  background: linear-gradient(90deg, var(--brand-primary), #4F8A10);
  color: white;
  box-shadow: 0 4px 15px rgba(102, 191, 1, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 191, 1, 0.4);
}

.btn-outline {
  background: #fff;
  color: #66BF01;
  border: 3px solid #66BF01;
  font-weight: 700;
  text-align: center;
}

.btn-outline:hover {
  background: rgba(102, 191, 1, 0.1);
  transform: translateY(-2px);
}

/* Loan Cards Preview */
.loan-cards-preview {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  position: relative;
  perspective: 1000px;
}

.loan-card {
  border-radius: 16px;
  padding: 1.5rem;
  color: white;
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.loan-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.6) 100%);
  z-index: 1;
}

.loan-card .card-content {
  position: relative;
  z-index: 2;
}

.loan-card h3 {
  font-size: 1.25rem;
  margin: 0 0 0.5rem 0;
  color: white;
}

.loan-card p {
  margin: 0 0 0.25rem 0;
  font-size: 0.95rem;
  opacity: 0.9;
}

.interest {
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  padding: 0.25rem 0.75rem;
  border-radius: 50px;
  font-size: 0.85rem;
  margin-top: 0.5rem;
  backdrop-filter: blur(5px);
}

/* Individual Card Styles */
.loan-card.business {
  background: linear-gradient(135deg, #4a6cf7 0%, #2541b2 100%);
  grid-column: 1 / -1;
  height: 200px;
}

.loan-card.personal {
  background: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);
}

.loan-card.home {
  background: linear-gradient(135deg, #ff6b6b 0%, #f06595 100%);
}

/* Hover Effects */
.loan-card:hover {
  transform: translateY(-5px) scale(1.02);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .loans-hero {
    padding: 4rem 0;
  }
  
  .hero-text h1 {
    font-size: 2.5rem;
  }
  
  .loan-cards-preview {
    margin-top: 2rem;
  }
}

@media (max-width: 768px) {
  .loans-hero-content {
    grid-template-columns: 1fr;
    text-align: center;
  }
  
  .features-list li {
    justify-content: center;
  }
  
  .cta-buttons {
    justify-content: center;
  }
  
  .loan-cards-preview {
    max-width: 500px;
    margin: 2rem auto 0;
  }
}

@media (max-width: 480px) {
  .hero-text h1 {
    font-size: 2rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
  
  .cta-buttons {
    flex-direction: column;
  }
  
  .btn {
    width: 100%;
  }
  
  .loan-card {
    height: 160px;
  }
  
  .loan-card.business {
    height: 180px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/LoansHero.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mDAA8X;EAC9X,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,iEAAiE;EACjE,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,iEAAiE;EACjE,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gFAAgF;EAChF,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,kBAAkB;AAClB;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Loans Hero Section - Updated Design */\n.loans-hero {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  padding: 5rem 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.loans-hero::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2366bf01' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n  z-index: 0;\n}\n\n.loans-hero-content {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  align-items: center;\n}\n\n.hero-text {\n  max-width: 600px;\n}\n\n.eyebrow {\n  display: inline-block;\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--brand-primary);\n  margin-bottom: 1rem;\n  background: rgba(102, 191, 1, 0.1);\n  padding: 0.5rem 1rem;\n  border-radius: 50px;\n}\n\n.hero-text h1 {\n  font-size: 2.75rem;\n  line-height: 1.2;\n  margin-bottom: 1.5rem;\n  color: var(--brand-dark);\n}\n\n.hero-text .gradient-text {\n  background: linear-gradient(90deg, var(--brand-primary), #4F8A10);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-weight: 800;\n}\n\n.subtitle {\n  font-size: 1.125rem;\n  color: var(--text-secondary);\n  margin-bottom: 2rem;\n  line-height: 1.7;\n}\n\n.features-list {\n  list-style: none;\n  padding: 0;\n  margin: 2rem 0;\n}\n\n.features-list li {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n  color: var(--text-primary);\n  font-weight: 500;\n}\n\n.feature-icon {\n  color: var(--brand-primary);\n  margin-right: 0.75rem;\n  flex-shrink: 0;\n  margin-top: 0.25rem;\n}\n\n.cta-buttons {\n  display: flex;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.btn {\n  padding: 0.875rem 1.75rem;\n  border-radius: 50px;\n  font-weight: 600;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border: 2px solid transparent;\n}\n\n.btn-primary {\n  background: linear-gradient(90deg, var(--brand-primary), #4F8A10);\n  color: white;\n  box-shadow: 0 4px 15px rgba(102, 191, 1, 0.3);\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 191, 1, 0.4);\n}\n\n.btn-outline {\n  background: #fff;\n  color: #66BF01;\n  border: 3px solid #66BF01;\n  font-weight: 700;\n  text-align: center;\n}\n\n.btn-outline:hover {\n  background: rgba(102, 191, 1, 0.1);\n  transform: translateY(-2px);\n}\n\n/* Loan Cards Preview */\n.loan-cards-preview {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1.5rem;\n  position: relative;\n  perspective: 1000px;\n}\n\n.loan-card {\n  border-radius: 16px;\n  padding: 1.5rem;\n  color: white;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  height: 180px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.loan-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(to bottom, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.6) 100%);\n  z-index: 1;\n}\n\n.loan-card .card-content {\n  position: relative;\n  z-index: 2;\n}\n\n.loan-card h3 {\n  font-size: 1.25rem;\n  margin: 0 0 0.5rem 0;\n  color: white;\n}\n\n.loan-card p {\n  margin: 0 0 0.25rem 0;\n  font-size: 0.95rem;\n  opacity: 0.9;\n}\n\n.interest {\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.2);\n  padding: 0.25rem 0.75rem;\n  border-radius: 50px;\n  font-size: 0.85rem;\n  margin-top: 0.5rem;\n  backdrop-filter: blur(5px);\n}\n\n/* Individual Card Styles */\n.loan-card.business {\n  background: linear-gradient(135deg, #4a6cf7 0%, #2541b2 100%);\n  grid-column: 1 / -1;\n  height: 200px;\n}\n\n.loan-card.personal {\n  background: linear-gradient(135deg, #00b09b 0%, #96c93d 100%);\n}\n\n.loan-card.home {\n  background: linear-gradient(135deg, #ff6b6b 0%, #f06595 100%);\n}\n\n/* Hover Effects */\n.loan-card:hover {\n  transform: translateY(-5px) scale(1.02);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .loans-hero {\n    padding: 4rem 0;\n  }\n  \n  .hero-text h1 {\n    font-size: 2.5rem;\n  }\n  \n  .loan-cards-preview {\n    margin-top: 2rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .loans-hero-content {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n  \n  .features-list li {\n    justify-content: center;\n  }\n  \n  .cta-buttons {\n    justify-content: center;\n  }\n  \n  .loan-cards-preview {\n    max-width: 500px;\n    margin: 2rem auto 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-text h1 {\n    font-size: 2rem;\n  }\n  \n  .subtitle {\n    font-size: 1rem;\n  }\n  \n  .cta-buttons {\n    flex-direction: column;\n  }\n  \n  .btn {\n    width: 100%;\n  }\n  \n  .loan-card {\n    height: 160px;\n  }\n  \n  .loan-card.business {\n    height: 180px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
